<template>
  <div
    :data-cy-sidebarParent="item.name"
    :class="['item-container', { active: isItemActive }]"
    @click="onItemClick()"
  >
    <a v-if="isExternalURL" :href="item.externalURL" :target="item.target">
      <NavigationItemContent :item="item" :active="isItemActive" />
    </a>
    <!-- The href is only the fallback for middle-click and "copy link" -->
    <a
      v-else-if="item.action"
      :href="$router.resolve({ name: item.name }).href"
      :target="item.target"
      @click.prevent="item.action()"
    >
      <NavigationItemContent :item="item" :active="isItemActive" />
    </a>
    <router-link v-else :to="{ name: item.name }" :target="item.target">
      <NavigationItemContent :item="item" :active="isItemActive" />
    </router-link>

    <!-- Sub-items -->
    <div v-if="showSubItems" class="subitems-container">
      <ul class="navigation-subitems-list">
        <li
          v-for="(child, index) in item.children"
          :key="index"
          :data-cy="`sidebar-${child.name}`"
          @click="onSubItemClick()"
        >
          <NavigationSubItem v-if="showItem(child)" :item="child" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavigationItemContent from '@/components/layout/sidebar/NavigationItemContent.vue'
import NavigationSubItem from '@/components/layout/sidebar/NavigationSubItem.vue'
import { checkAccessForSidebar } from '@/helpers/routeAccessValidation.js'
import { mapState } from 'vuex'

export default {
  components: {
    NavigationItemContent,
    NavigationSubItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isMobileMenuOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['exitMobileMenu'],
  data() {
    return {
      activeSubItem: 0,
    }
  },
  computed: {
    ...mapState({
      currentCompany: (state) => state.common.currentCompany,
      currentUser: (state) => state.common.currentUser,
    }),
    isItemActive() {
      return this.item.isOpen
    },
    hasSubItems() {
      return this.item.children.length > 0
    },
    isExternalURL() {
      return 'externalURL' in this.item
    },
    showSubItems() {
      return this.hasSubItems && this.isItemActive
    },
  },
  methods: {
    showItem(item) {
      return checkAccessForSidebar(
        this.currentCompany,
        this.currentUser,
        this.$router,
        this.$ability,
        item
      )
    },
    onItemClick() {
      if (this.isMobileMenuOpen && !this.hasSubItems) {
        this.$emit('exitMobileMenu')
      }
    },
    onSubItemClick() {
      if (this.isMobileMenuOpen) {
        this.$emit('exitMobileMenu')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: $border-radius-l;

  &:hover {
    background: $color-paper;
  }

  &:active {
    background: $color-canvas;
  }

  /* TODO: Rename to 'Selected' */
  &.active {
    background: $color-canvas;
  }

  .subitems-container {
    margin-left: $spacing-4xs;
    padding: 0 $spacing-4xs $spacing-4xs $spacing-2xs;
  }

  .navigation-subitems-list {
    display: flex;
    flex-direction: column;
    border-left: 1px solid $color-border;
    font-size: $font-size-s;
    padding-left: $spacing-3xs;

    @media screen and (min-width: $large-desktop-width-max) {
      padding-left: $spacing-xs;
    }
  }
}
</style>
